export default __webpack_public_path__ + "static/media/personal.f2922ec2.svg";